'use es6';

import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
const ENDPOINT = 'eligibility-engine/v2/retail';
export const getIsRetail = () => {
  const earlyRequest = getEarlyRequesterResult('retail');
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};